var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentCard',{attrs:{"title":"系统通知","rightTitle":"更多"},on:{"rightClick":_vm.goMore}},[_c('InfoList',{attrs:{"list":_vm.list},on:{"detail":_vm.openNoticePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }